export default __webpack_public_path__ + "static/media/minisite-pagetype-contact.2155b17d.svg";